import {APP_INITIALIZER, InjectionToken, Provider} from '@angular/core';
import { SERVICE_REPOSITORY } from '../../domain/tokens/service.token';
import { SERVICE_STORE } from '../../domain/tokens/service-store.token';
import {ServiceState, ServiceStore} from '../../application/stores/service.store';
import { HttpServiceAdapter } from '../adapters/http-service-repository.adapter';
import { FeedbackPort } from '@platform/feedback/domain/ports/feedback.port';
import { FeedbackAdapter } from '@platform/feedback/infrastructure/adapters/feedback.adapter';
import { ServiceSelectionCompleteSubscriber } from '../subscribers/service-selection-complete.subscriber';
import { ServiceRedirectPort } from '../../domain/port/service-redirect.port';
import { ServiceRedirectAdapter } from '../adapters/service-redirect.adapter';
import { ServiceCleanDataSubscriber } from '../subscribers/service-clean-data.subscriber';
import { ServiceChangeWorkerSubscriber } from '../subscribers/service-change-worker.subscriber';
import { ServiceChangeDrawerSubscriber } from '../subscribers/service-change-drawer.subscriber';
import { ServiceOnInitialDataDoneSubscriber } from '../subscribers/service-on-initial-data-done.subscriber';
import { ServiceEmptyStateRedirectSubscriber } from '../subscribers/service-empty-state-redirect.subscriber';
import { ServiceLocationSubscriber } from '../subscribers/service-location.subscriber';
import {ServiceDrawerSubscriber} from '../subscribers/service-drawer.subscriber';
import {ServiceDeviceSubscriber} from '../subscribers/service-device.subscriber';
import {SERVICE_STORE_STORAGE} from "@features/service/infrastructure/tokens/service-store-storage.token";
import {Logger} from "@core/interfaces/Logger";
import {StoreIndexedDbStorage} from "@platform/storage/infrastructure/storage-indexdb.storage";
import {StorageSynchronizer} from "@platform/storage/application/storage.synchronizer";

export const DOMAIN_SUBSCRIBERS = new InjectionToken<unknown[]>('DOMAIN_SUBSCRIBERS');

export const SERVICE_PROVIDERS: Provider[] = [
  {
    provide: SERVICE_REPOSITORY,
    useClass: HttpServiceAdapter,
  },
  {
    provide: SERVICE_STORE,
    useExisting: ServiceStore,
  },
  {
    provide: FeedbackPort,
    useClass: FeedbackAdapter,
  },
  {
    provide: ServiceRedirectPort,
    useClass: ServiceRedirectAdapter,
  },
  {
    provide: DOMAIN_SUBSCRIBERS,
    useClass: ServiceSelectionCompleteSubscriber,
    multi: true
  },
  {
    provide: DOMAIN_SUBSCRIBERS,
    useClass: ServiceCleanDataSubscriber,
    multi: true
  },
  {
    provide: DOMAIN_SUBSCRIBERS,
    useClass: ServiceChangeWorkerSubscriber,
    multi: true
  },
  {
    provide: DOMAIN_SUBSCRIBERS,
    useClass: ServiceChangeDrawerSubscriber,
    multi: true
  },
  {
    provide: DOMAIN_SUBSCRIBERS,
    useClass: ServiceOnInitialDataDoneSubscriber,
    multi: true
  },
  {
    provide: DOMAIN_SUBSCRIBERS,
    useClass: ServiceLocationSubscriber,
    multi: true
  },
  {
    provide: DOMAIN_SUBSCRIBERS,
    useClass: ServiceDrawerSubscriber,
    multi: true
  },
  {
    provide: DOMAIN_SUBSCRIBERS,
    useClass: ServiceEmptyStateRedirectSubscriber,
    multi: true
  },
  {
    provide: DOMAIN_SUBSCRIBERS,
    useClass: ServiceDeviceSubscriber,
    multi: true
  },
  {
    provide: SERVICE_STORE_STORAGE,
    useFactory: (logger: Logger) => new StoreIndexedDbStorage<ServiceState>(logger, 'service'),
    deps: [Logger]
  },
  {
    provide: APP_INITIALIZER,
    useFactory: (storage: StoreIndexedDbStorage<ServiceState>, store: ServiceStore) => new StorageSynchronizer<ServiceState>(storage, store).sync(),
    deps: [SERVICE_STORE_STORAGE, ServiceStore],
    multi: true
  },
  {
    provide: APP_INITIALIZER,
    multi: true,
    useFactory: (subscribers: unknown[]) => () => void subscribers,
    deps: [DOMAIN_SUBSCRIBERS]
  }
];
